import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { BookIcon, HistoryIcon, StarIcon, CreditCardIcon } from '../Icons';
import './Sidebar.css';

function Sidebar({ onOpenAuth, isOpen, onClose }) {
  const { isAuthenticated } = useAuth();

  // Fermer le sidebar automatiquement quand on redimensionne au-dessus de 900px
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 900 && isOpen) {
        onClose();
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isOpen, onClose]);

  // Fermer le sidebar quand on clique sur un lien (sur mobile)
  const handleLinkClick = () => {
    if (window.innerWidth <= 900) {
      onClose();
    }
  };

  return (
    <>
      {/* Overlay pour fermer le sidebar sur mobile */}
      {isOpen && <div className="sidebar-overlay" onClick={onClose}></div>}
      <aside className={`sidebar ${isOpen ? 'sidebar-open' : ''}`}>
      {/* Navigation principale */}
      <nav className="sidebar-nav">
        <NavLink 
          to="/" 
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          end
          onClick={handleLinkClick}
        >
          <BookIcon className="nav-icon" />
          <span className="nav-label">Générer un cours</span>
        </NavLink>

        <NavLink 
          to="/history" 
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          onClick={handleLinkClick}
        >
          <HistoryIcon className="nav-icon" />
          <span className="nav-label">Historique</span>
        </NavLink>

        <NavLink 
          to="/pricing" 
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          onClick={handleLinkClick}
        >
          <CreditCardIcon className="nav-icon" />
          <span className="nav-label">Nos offres</span>
        </NavLink>

        <NavLink 
          to="/ratings" 
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          onClick={handleLinkClick}
        >
          <StarIcon className="nav-icon" />
          <span className="nav-label">Evaluez nous !</span>
        </NavLink>
      </nav>

      {/* Info connexion si non connecté */}
      {!isAuthenticated && (
        <>
          <div className="sidebar-divider"></div>
          <div className="sidebar-auth-prompt">
            <p>Connectez-vous pour sauvegarder vos cours</p>
            <button className="sidebar-login-btn" onClick={onOpenAuth}>
              Se connecter
            </button>
          </div>
        </>
      )}

      {/* Footer sidebar */}
      <div className="sidebar-footer">
        <div className="sidebar-info">
          <span className="info-text">Génération IA - Mistral</span>
        </div>
      </div>
    </aside>
    </>
  );
}

export default Sidebar;
